import { render, staticRenderFns } from "./page-navigator.vue?vue&type=template&id=37039bb9&scoped=true"
import script from "./page-navigator.vue?vue&type=script&lang=js"
export * from "./page-navigator.vue?vue&type=script&lang=js"
import style0 from "./page-navigator.vue?vue&type=style&index=0&id=37039bb9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37039bb9",
  null
  
)

export default component.exports